import { authenticatedFetch } from './request';

export default async function fetchAuthenticatedDoctor() {
    return await authenticatedFetch('/doctor-data/whoami');
}
